import { render, staticRenderFns } from "./RemediationGenerateRrr.vue?vue&type=template&id=2ba12968&scoped=true"
import script from "./RemediationGenerateRrr.vue?vue&type=script&lang=js"
export * from "./RemediationGenerateRrr.vue?vue&type=script&lang=js"
import style0 from "./RemediationGenerateRrr.vue?vue&type=style&index=0&id=2ba12968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba12968",
  null
  
)

export default component.exports